import { render, staticRenderFns } from "./accounting.vue?vue&type=template&id=2ea3a886&scoped=true&"
import script from "./accounting.vue?vue&type=script&lang=js&"
export * from "./accounting.vue?vue&type=script&lang=js&"
import style0 from "./accounting.vue?vue&type=style&index=0&id=2ea3a886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3a886",
  null
  
)

export default component.exports